import L10n from "../../../lib/carrot-l10n"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { Spacer } from "../atoms/Atoms"
import { BodySmall } from "../atoms/Bodies"
import React from "react"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { Paths } from "../../../utils/Paths"
import { H3 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const CarrotPlanModule = () => (
  <RoundedRectangle id="home-sidebar-carrot-plan-module" backgroundColor="light-gray">
    <H3 variant="primary" stack="tiny">{l`Has anything changed?`}</H3>
    <BodySmall color="black-80">Refresh your Carrot Plan by sending us an update.</BodySmall>
    <Spacer height={1.5} />
    <ArrowLink to={Paths.REFRESH_CARROT_PLAN}>{l`Refresh Carrot Plan`}</ArrowLink>
  </RoundedRectangle>
)
